<template src="./template.html" />

<script>
import moment from "moment";
import {getGalleryShow, getGertShow} from "@/api/gallery";
import {
  queryCertificateClassification,
  queryHotWords,
  queryCertificatesList,
  addCollection,
  cancelCollection,
  downLoadCertificates,
  addFeedback,
  queryViewCertificateLink,
  checkReminderById,
  getAssociation,
  queryCertificateFeedback,
  JudgingCertificates
} from "@/api/certificateList";
import { formattedDate } from "@/utils/formattedDate";
import {isArrayEmpty, isStringEmpty} from "@/utils/isEmpty";
// import {validateContact} from "@/utils/validate";

// 备份数据
let initCertificateSift = []

function getResult(condition) {
  const resultMapping = {
    'no': '型式试验证书',
    'type0': '型式试验报告',
    'type1': '主机',
    'type2': '控柜',
    'type3': '安全钳',
    'type4': '限速器',
    'type5': '缓冲器',
    'type6': '上超保护',
    'type7': '可编辑电路',
    'type8': '门锁',
    'type9': '其他补充证书',
    'note': '备注'
    // 添加更多的条件和对应的结果
  }
  // 检查条件并返回结果
  return resultMapping[condition] || 'Default result'
}

export default {
  name: "pchome",
  data() {
    return {
      typeId: 0,
      source: 'category',
      showPic: false,
      show: false,
      showFilter:true,
      menu: "",
      hot: 2,
      categoryInfo: {
        categories: [],
        recommendCategories: [],
      },
      selectedIds: [],
      searchText: "",
      pageNum: 1,
      totalPages: 0,
      keywords: ["办公文档", "流程演示文档", "产品需求文档", "市场运营文档"],
      list2: [],
      list: [],
      dataList: {
        recommendCategories: ["公司介绍", "演示资料", "产品介绍"],
        categories: [],
      },
      loadinng: false,
      nomore: false,
      userList: "",
      dialogUser: false,
      scroll: null,
      // 资料分类
      infoCategory: [],
      // 反馈的分类
      fedbackCategory: [],
      // 资料分类选项配置
      infoCategoryDefaultProps: {
        children: 'children',
        value: 'id',
        label: 'name',
        // checkStrictly: true
      },
      // 当前选择的资料分类
      infoCategoryIndex: -1,
      // 关键词搜索类型选项
      searchKeyWordTypeOptions: {
        type: [
          [0,1,2,3],
          [0,2,3,4,5,6,7,8]
        ],
        data: [
          { id: 0, name: '证书名称' },
          { id: 1, name: '发证机构' },
          { id: 2, name: '标签搜索' },
          { id: 3, name: '全文搜索' },
          { id: 4, name: '证书编号' },
          { id: 5, name: '下次核查形式' },
          { id: 6, name: '标准' },
          { id: 7, name: '型号规格' },
          { id: 8, name: '主要部件和新能指标' },
          { id: 9, name: '备注' },
        ]
      },
      // 形式配置选项
      formAppearanceArray: [
        { id: 0, name: '全部形式' },
        { id: 1, name: '牌匾' },
        { id: 2, name: '证书' },
        { id: 3, name: '公式名单' },
        { id: 4, name: '奖杯' },
        { id: 5, name: '奖牌' },
        { id: 6, name: '电子文件' },
        { id: 7, name: '电子版' },
        { id: 8, name: '证书+水晶' },
        { id: 9, name: '证书+牌匾' },
        { id: 10, name: '牌匾和批准通知' },
        { id: 11, name: '其他' },
      ],
      // 状态选项配置
      statusArray: [
        { id: null, name: '全部状态' },
        { id: 1, name: '生效中' },
        { id: 2, name: '即将失效' },
        { id: 3, name: '已更新' },
        { id: 0, name: '已失效' },
      ],
      // 投标证书筛选结果
      certificateSift: {
        // 资料分类
        infoCategoryOptions: [],
        // 关键词搜索
        keywordSearch: {
          id: 0,
          value: ''
        },
        // 获取时间
        time: null,
        // 形式
        formAppearance: 0,
        // 有效年限
        validTime: null,
        // 状态
        status: null
      },
      // 热词数组
      hotWords: [],
      // 当前选择的热词
      currentHotWords: -1,
      // 证书类型
      certifType: 1,  // 1 普通证书 2 型报证书
      // 证书列表
      certifData: [],
      currentPage: 1, // 当前页码
      pageSize: 10,   // 每页显示的条数
      totalRows: 0,    // 总条数
      // 是否申领流程弹窗
      claimdialogVisible: false,
      // 申领流程
      claimProcess: null,
      // 当前操作的证书id
      currentCertificateId: null,
      // 是否显示备注弹窗
      remarksDialogVisible: false,
      // 备注信息
      remarksValue: '',
      // 是否添加备注信息
      isRemarksValue: false,
      // 是否显示反馈缺证情况弹窗
      showFeedbackLackDialog: false,
      // 反馈类型
      feedbackType: [
        {id: 1, name: '缺证反馈'},
        {id: 2, name: '操作反馈'},
        {id: 3, name: '功能反馈'},
        {id: 4, name: '内容反馈'},
        {id: 5, name: '意见和建议'},
        {id: 6, name: '其他'}
      ],
      // 反馈内容
      feedbackData: {
        // 类型
        type: null,
        // 证书分类id
        classificationId: '',
        // 上报内容
        content: '',
        // 反馈附件
        attachment: [],
        // 联系方式
        contact: ''
      },
      // 是否缺证反馈
      lackCertificateFeedback: false,
      showAssociatedCertificateTableDialog: false,
      mainCertificateNo: null,
      relevanceCertificateData: [],
      filteringRelevanceCertificateData: [],
      // 关联证书表页码
      relevanceCertificateTablePageNumber: 1,
      roleShow: true,
      // 控制是否进行了搜索
      isSearch: false,
      menuPermissions: 0 // 0正常 1 投标证书 2 普通菜单 3 型报
    };
  },
  filters: {
    dateFormatter(val) {
      return moment(val).format("YYYY-MM-DD HH:mm");
    },
    filterDate(val) {
      /* 过滤时间 */
      if (!val) return '/'
      return formattedDate(val) || '/'
    },
  },
  mounted() {
    if (this.$route.path.split('menu=')[1] === 'tenderCertificate') {
      // TODO: 后续删除
      setTimeout(() => {
        this.changeMenu('tenderCertificate')
      }, 500)
    }
    window.addEventListener("scroll", this.handleScroll, true);
    this.getCateList();
    // this.categoryInfo = this.dataList
    // this.initMenu()
    this.getuser();
    this.getShowPic()
    this.getRole()
    /* 投标证书模块 */
    // this.getCertificateClassification()
    // this.getHotWords(0)
    // this.getCertificatesList()
    // 备份数据
    this.backupCertificateSift()
    this.getCertificateFeedback()
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    row() {
      return row
    },
    subMenuList() {
      let result = this.categoryInfo.categories.find(item => item.categoryId == this.menu);
      if (result) {
        console.log(result, "计算属性");
        return result.twoLevelChildren;
      }
      return [];
    },
    filterSearchKeyWordTypeOptions() {
      /* 过滤关键词下拉框选项 */
      const filterArray = this.searchKeyWordTypeOptions.data.filter(obj => this.searchKeyWordTypeOptions.type[this.certifType-1].includes(obj.id))
      // console.log(filterArray)
      return filterArray
    },
    filterStatus() {
      /* 过滤状态 */
      // 1:生效中0:已失效,2：即将失效，3：已更新
      return (status) => {
        // 默认失效 0
        let statusObj = {
          str: '/',
          color: '#cccccc',
          flag: false
        }
        // if (status) statusObj.flag = true
        switch (status) {
          case 0:
            statusObj.str = '已失效'
            break
          case 1:
            statusObj.str = '生效中'
            statusObj.color = '#00B42A'
            statusObj.flag = true
            break
          case 2:
            statusObj.str = '即将失效'
            statusObj.color = '#D0202E'
            statusObj.flag = true
            break
          case 3:
            statusObj.str = '已更新'
            // statusObj.color = '#00B42A'
            break
        }
        return statusObj
      }
    },
  },
  methods: {
    // 正式访问权限
    getRole() {
      getGertShow().then(res => {
        this.roleShow = res.data
      })
    },
    // 应用图库访问权限
    getShowPic() {
      getGalleryShow().then(res => {
        this.showPic = res.data
      })
    },
    onGalleryClick() {
      this.$router.push("/gallery");
    },
    getNewProject() {
      this.$router.push("/manage/newproject");
    },
    getUserManage() {
      this.dialogUser = true;
    },
    handleKeyClick(key) {
      console.log(key);
      this.searchText = key;
      this.handleSearch();
    },
    goPage(page) {
      if (page == 1) {
        this.$openWindow("https://lexiangla.com/questions?company_from=db4cbf76a76111ec93886a56b1ecba05");
      }
      if (page == 2) {
        this.$openWindow("https://lexiangla.com/docs?company_from=db4cbf76a76111ec93886a56b1ecba05");
      }
      if (page == 3) {
        this.$openWindow("https://lexiangla.com/staff/teams?company_from=db4cbf76a76111ec93886a56b1ecba05");
      }
      if (page == 4) {
        this.$openWindow("https://lexiangla.com/staff?company_from=db4cbf76a76111ec93886a56b1ecba05");
      }
    },
    goUrl(link) {
      if (link) {
        window.open(link);
      }
    },
    handleClear() {
      this.handleSearch()
    },
    handleSearch() {
      if(this.searchText?.length>0){
        this.menu = undefined
        this.showFilter = false
        this.selectedIds = undefined
      }else{
        const categoryId = this.categoryInfo.categories[0].categoryId;
        this.menu = categoryId
        this.selectedIds = [categoryId]
        this.showFilter = true
      }
      this.pageNum = 1;
      this.getDocList();
    },
    handleScroll() {
      // 是否处于证书列表模块
      if (this.menu === 'tenderCertificate') return
      // console.log(this.menu)
      // 变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // 变量windowHeight是可视区的高度
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      // 变量scrollHeight是滚动条的总高度
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      // 滚动条到底部的条件
      if (scrollTop + windowHeight - scrollHeight>-10) {
        if (this.pageNum == this.totalPages || this.nomore || this.loadinng) {
          return;
        }
        this.pageNum++;
        this.getDocList();
      }
    },
    // 显示型报证书和普通证书
    showCert() {
      JudgingCertificates().then(res => {
        if(res.data.is_category && !res.data.is_modelCategory){
          this.source = 'category'
          this.menuPermissions = 3
          this.certifType = 1
          this.typeId = 0
        } else if(!res.data.is_category && res.data.is_modelCategory) {
          this.source = 'modelCategory'
          this.menuPermissions = 2
          this.certifType = 2
          this.typeId = 1
        } else {
          this.source = 'category'
          this.menuPermissions = 0
          this.certifType = 1
          this.typeId = 0
        }
      })
    },
    changeMenu(cid) {
      // 控制没有任何分类的情况
      if (this.menuPermissions === 1 && cid === 'tenderCertificate') {
        return this.$message.error('您没有查看权限!')
      }
      // console.log(cid)
      this.menu = cid;
      if (cid === 'tenderCertificate') {
        this.showCert()
        if (this.totalRows === 0) {
          this.getCertificateClassification()
          this.getHotWords(this.typeId)
          this.getCertificatesList()
        }
        console.log(this.source)
      } else {
        this.pageNum = 1;
        this.selectedIds = [cid];
        this.initMenu();
        this.getDocList();
      }
    },
    getCateList() {
      this.$request.getCategoryList().then(res => {
        // console.log(res, 'cate');
        if (res.code == 200) {
          this.categoryInfo = res.data;
          this.menu = this.categoryInfo.categories[0].categoryId;
          this.selectedIds = [this.menu];
          this.initMenu();
        }
        this.getDocList();
      });
    },
    initMenu() {
      // let menuObj = this.categoryInfo.categories.find(item => item.categoryId == this.menu);
      // let selectedIds = []
      // menuObj.twoLevelChildren.forEach((item) => {
      //   item.threeLevelChildren.forEach((sitem) => {
      //     if (sitem.categoryName == '全部') {
      //       selectedIds.push(sitem.categoryId)
      //     }
      //   })
      // })
      // this.selectedIds = selectedIds
    },
    getDocList() {
      this.nomore = false;
      this.loadinng = true;
      let postData = {
        categoryIds: this.selectedIds,
        searchContext: this.searchText,
        type: this.hot,
        pageNum: this.pageNum,
        pageSize: 10,
      };
      this.$request
        .getDocumentList(postData)
        .then(res => {
          console.log(res, 123);
          if (res.code == 200) {
            if (this.pageNum == 1) {
              this.list = res.data.records||[];
            } else {
              this.list = [...this.list, ...res.data.records||[]];
            }
            this.totalPages = res.data.pages;
            if (this.totalPages == this.pageNum || this.totalPages === 0) {
              this.nomore = true;
            }
          }
        })
        .finally(() => {
          this.loadinng = false;
        });
    },
    changeFilter(cid) {
      if (this.selectedIds.indexOf(cid) == 0) {
        this.selectedIds = [];
      } else {
        this.selectedIds = [cid];
      }
      this.pageNum = 1;
      this.getDocList();
    },
    changeHot(hot) {
      this.hot = hot;
      this.pageNum = 1;
      this.getDocList();
    },
    // 获取用户的信息
    getuser() {
      this.$store
        .dispatch("user/getInfo")
        .then(res => {
          this.userList = res;
          console.log(this.userList, "用户信息");
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 退出登录
    getOut() {
      this.$request
        .getOut(this.userList.id)
        .then(res => {
          if (res.code === 200) {
            this.$message.success("退出登录成功");
            localStorage.removeItem("code");
            localStorage.removeItem("lxState");
            this.$router.push("/login");
            localStorage.removeItem("UserAdmin")();
            window.location.reload();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    backupCertificateSift() {
      /* 备份筛选结果的默认数据 */
      // console.log(this.certificateSift)
      initCertificateSift = JSON.parse(JSON.stringify(this.certificateSift))
    },
    resetCertificateSift() {
      this.isSearch = false
      /* 清空操作 */
      this.certificateSift = JSON.parse(JSON.stringify(initCertificateSift))
      this.infoCategoryIndex = -1
      this.getHotWords(this.typeId)
      this.currentPage = 1
      this.getCertificatesList()
    },
    inquireCertificateList() {
      this.isSearch = true
      /* 查询证书列表 */
      // console.log(this.certificateSift)
      this.currentPage = 1
      this.getCertificatesList()
    },
    async getCertificateClassification() {
      /* 获取资料分类 */
      const res = await queryCertificateClassification(
        this.certifType === 1 ? 'category' : 'modelCategory'
      )
      console.log('资料分类', res)
      if (res.code === 200) {
        this.infoCategory = res.data
        this.infoCategory?.map(item => {
          this.certificateSift.infoCategoryOptions.push(item.directoryId)
        })
        // console.log(this.infoCategory)
      }
    },
    // 获取反馈分类
    async getCertificateFeedback() {
      const res = await queryCertificateFeedback()
      if (res.code === 200) {
        this.fedbackCategory = res.data
        console.log(res.data)
        // TODO: 判断是否存在型报证书 ！！！
        // 没有任何分类时
        if (!res.data || res.data.length === 0) {
          return this.menuPermissions = 1
        }
        let result = null
        res.data.forEach(c => {
          if (c.directoryId === "d4807d0cd12811ee8bea669f0a8993cc" || c.directoryId === "38637f70d1f311ee992aea5ee6abf380") {
            return result = true
          }
        })
        this.showCert()
        if(!result){
          this.menuPermissions = 3
          this.certifType = 1
        } else if(res.data.length === 1) {
          this.menuPermissions = 2
          this.certifType = 2
        } else {
          this.menuPermissions = 0
          this.certifType = 1
        }
      }
    },
    async getHotWords(id) {
      /* 根据分类id获取热词 */
      const res = await queryHotWords(id)
      // console.log('热词', res)
      if (res.code === 200) {
        // 清空已选择的热词
        this.currentHotWords = -1
        console.log(res.data, 22222)
        // 更新热词
        this.hotWords = res.data
      }
    },
    async getCertificatesList() {
      /* 获取证书列表 */

      // 处理资料分类
      let classificationIds = null
      if (this.infoCategoryIndex !== -1) {
        classificationIds = [this.certificateSift.infoCategoryOptions[this.infoCategoryIndex]]
      }
      // console.log(classificationIds)

      // 处理获取时间
      let strDate = null
      let endDate = null
      if (this.certificateSift.time) {
        strDate = formattedDate(this.certificateSift.time[0])
        endDate = formattedDate(this.certificateSift.time[1])
      }

      // 处理有效年限
      let strDate2 = null
      let endDate2 = null
      if (this.certificateSift.validTime) {
        strDate2 = formattedDate(this.certificateSift.validTime[0])
        endDate2 = formattedDate(this.certificateSift.validTime[1])
      }

      // 处理形式
      let form = ''
      if (this.certificateSift.formAppearance) {
        const filterArray = this.formAppearanceArray.filter(obj => obj.id === this.certificateSift.formAppearance)
        form = filterArray[0].name
      }
      // console.log('form', form)

      let params = {
        from: 0,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        type2: this.certifType,
        strDate,
        endDate,
        strDate2,
        endDate2,
        classificationIds,
        content: this.certificateSift.keywordSearch.value || null,
        type3: this.certificateSift.keywordSearch.id,
        form,
        stateFlag: this.certificateSift.status,
        source: this.source
      }

      const res = await queryCertificatesList(params)
      if (res.code === 200) {
        this.certifData = res.data.records
        this.totalRows = res.data.total
        // 禁止失效证书点击状态
        // this.$nextTick(() => {
        //   const disableRow = document.querySelectorAll('.disabled-row')
        //   disableRow.forEach(h => {
        //     h.addEventListener('click', function (event) {
        //       event.stopPropagation();
        //     });
        //   })
        // })
      }
      console.log('证书列表', res)
    },
    async handleAddCollection(id) {
      /* 收藏 */
      const res = await addCollection(
        id,
        this.remarksValue ? this.remarksValue : null
      )
      // 成功处理，更新证书收藏状态
      if (res.code === 200) {
        this.certifData.map(certificate => {
          if (certificate.id === id) (certificate.likeFlag = true)
        })
        this.$message('已收藏')
      } else {
        this.$message.error('收藏失败');
      }
      // 恢复默认
      this.isRemarksValue = false
      this.currentCertificateId = null
      this.remarksValue = ''
    },
    async handleCancelCollection(id) {
      /* 取消收藏 */
      const res = await cancelCollection(id)
      // console.log(res)
      // if (res.code === 200) {
      //
      // } else {
      //
      // }
      // 成功处理，更新证书收藏状态
      this.certifData.map(certificate =>{
       if ( certificate.id === id) (certificate.likeFlag = false)
      })
      this.$message('已取消收藏')
      // 恢复默认
      this.currentCertificateId = null
    },
    handleInfoCategoryDropdownChange(selectedIndex) {
      /*
        当某个下拉框的选项发生变化时
        selectedIndex 决定选择某个下拉框的值
      */
      // 更新列表数据
      this.isSearch = true
      this.currentPage = 1
      this.getCertificatesList()
    },
    handleInfoCategoryDropdownFocus(index) {
      /* 当分类下拉框获取焦点时，表示切换到当前一级分类 */
      // 清空其他分类的选项
      if (index >= 0 && index < this.certificateSift.infoCategoryOptions.length) {
        // 确保下标在数组范围内
        // 清空除了指定下标的值以外的所有值
        this.certificateSift.infoCategoryOptions.fill(undefined, 0, index).fill(undefined, index + 1);
      }
      // 默认选择第一个
      this.certificateSift.infoCategoryOptions[index] = this.infoCategory[index].directoryId
      // 更新当前选择的资料分类
      this.infoCategoryIndex = index
      // 获取id（直接获取一级分类id）
      const id = this.infoCategory[this.infoCategoryIndex].id
      // 更新热词
      this.getHotWords(id)
      // 更新列表数据
      this.isSearch = true
      this.currentPage = 1
      this.getCertificatesList()
    },
    handleInfoCategoryDropdownBlur(index) {
      /* 当分类下拉框失去焦点时 */
      // console.log(this.certificateSift.infoCategoryOptions)
    },
    selectHotWord(word) {
      this.isSearch = true

      this.currentHotWords = this.currentHotWords === word.id ? -1 : word.id

      // 将热词填入输入框
      if (this.currentHotWords !== -1) {
        // console.log(this.currentHotWords)
        this.certificateSift.keywordSearch.value = word.content
      } else {
        this.certificateSift.keywordSearch.value = ''
      }
      this.currentPage = 1
      // 更新列表
      this.getCertificatesList()
    },
    switchCertif(id) {
      if(id === 1) {
        this.source = 'category'
        this.typeId = 0
      } else if(id === 2) {
        this.typeId = 1
        this.source = 'modelCategory'
      }
      console.log(this.typeId, 122222)
      this.isSearch = false
      /* 切换不同证书类型列表 */
      this.certifType = id
      this.getCertificateClassification()
      this.certifData = []
      this.resetCertificateSift()
      // this.getCertificatesList() // 清空操作会重新获取列表数据
    },
    tableRowClassName({row}) {
      /*
        设置 Table 中的某一行处于某种状态
        disabled-row 失效
        失效置灰处理
      */
      if( !this.filterStatus(row.stateFlag).flag ) {
        return 'disabled-row'
      }
      return '';
    },
    handleCollection(row) {
      /* 收藏操作 */
      // console.log(row)
      this.currentCertificateId = row.id
      // 判断是否已收藏
      if (!row.likeFlag) {
        // 首先显示弹窗
        this.remarksDialogVisible = true
        return
      }
      // 处理取消收藏
      this.$confirm('确定取消收藏嘛？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleCancelCollection(row.id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
        // 恢复默认
        this.currentCertificateId = null
      });
    },
    closeRemarksDialog() {
      /* 弹窗关闭时 */
      // console.log(this.remarksValue)
      // 判断是否要收藏该证书
      if(this.isRemarksValue) {
        // 处理添加收藏
        this.handleAddCollection(this.currentCertificateId)
      } else {
        this.$message({
          type: 'info',
          message: '已取消'
        });
        // 恢复默认
        this.currentCertificateId = null
        this.remarksValue = ''
      }
    },
    handleSizeChange(size) {
      /* pageSize(每页条数) 改变时重新渲染列表 */
      this.pageSize = size
      this.currentPage = 1
      // 重新请求数据
      this.getCertificatesList()
    },
    handleCurrentChange(num) {
      /* currentPage 改变时根据页码获取对应列表 */
      this.getCertificatesList()
      // 回到列表顶部
      // this.$refs.certifListRef.$el.scrollTo(0, 0);
    },
    showProcessPopup(row) {
      /* 显示申领流程弹窗 */
      // console.log(row)
      this.claimProcess = row.getProcedure
      this.claimdialogVisible = true
    },
    // 获取并跳转证书详情地址
    async getCertificateDetailLink(id) {
      const link = await queryViewCertificateLink(id)
      // console.log(link)
      if (link.code === 200) window.open(link.msg, '_blank')
    },
    // 查看证书
    async viewCertificate(row) {
      // const check = await checkReminderById(row.id)
      // if(!(typeof check.data === 'boolean' && check.data === true)) {
      //   this.$confirm(check.msg, '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     this.getCertificateDetailLink(row.id)
      //   }).catch(() => {});
      // } else {
      //   this.getCertificateDetailLink(row.id)
      // }
      this.getCertificateDetailLink(row.id)
    },
    // 查询关系证书
    async queryAssociation(no) {
      const res = await getAssociation(no)
      // console.log('查询的关联证书', res)
      if (res.code === 200) {
        // 清空过滤列表数据
        this.filteringRelevanceCertificateData = []
        // 查询无绑定关系结果时
        console.log(res.data)
        if (JSON.stringify(res.data) === '{}' || res.data.length === 0) {
          this.filteringRelevanceCertificateData.push(this.filterAssociatedCertificate())
          return
        }
        this.relevanceCertificateData = res.data
        res.data.forEach(item => {
          this.filteringRelevanceCertificateData.push(this.filterAssociatedCertificate(item))
        })
        // console.log(this.filteringRelevanceCertificateData)
      }
    },
    // 过滤关联证书数据
    filterAssociatedCertificate(obj) {
      // console.log('obj', obj)
      const result = []
      result.push({
        name: getResult(`no`),
        type: 'no',
        data: obj.no ? [obj.no] : [this.mainCertificateNo]
      })
      for (let i = 0; i < Object.keys(obj).filter(key => key.startsWith('type')).length; i++) {
        result.push({
          name: getResult(`type${i}`),
          type: `type${i}`,
          data: obj ? JSON.parse(JSON.stringify(obj[`type${i}`])) : []
        })
      }
      // result.push({ name: getResult(`note`), type: 'note', data: obj.note || null })
      result.push({ name: getResult(`note`), type: 'note', data: obj.note ? [obj.note] : [] })
      // console.log('过滤的关联证书数据', result)
      return result
    },
    // 查看关联证书
    linkOthers(row, index) {
      console.log(row)
      if (row.no === null || row.hasAssociation !== true) {
        // this.$message.warning('该证书不存在编号！')
        return
      }

      // console.log(row, index)
      this.showAssociatedCertificateTableDialog = true
      this.mainCertificateNo = row.no
      this.queryAssociation(row.no)
    },
    // 设置关联证书行样式
    setRelevanceContainerRowClassName({ rowIndex }) {
      const flag = this.relevanceCertificateData[this.relevanceCertificateTablePageNumber - 1].flag
      // console.log(flag)
      // flag -1开始（型式实验证书）
      if (flag + 1 === rowIndex || flag === undefined && rowIndex === 0) {
        return 'red-relevance-row'
      }
      return ''
    },
    // 根据编号打开证书
    jumpAssociatedNumberCertificate(number) {

    },
    // 关联证书当前页发生变化时
    currentAssociationListChange(val) {
      this.relevanceCertificateTablePageNumber = val
    },
    // 隐藏关联证书弹窗时
    hiddenAssociatedCertificateDialog() {
      this.filteringRelevanceCertificateData = []
      this.relevanceCertificateData = []
      this.relevanceCertificateTablePageNumber = 1
      this.mainCertificateNo = null
    },
    async handleDownLoadCertificates(row) {
      /* 下载证书 */
      // console.log('下载证书', row)
      let promptConfig = {
        title: '证书下载',
        content: '确定需要下载该证书吗？',
        type: 'info',
        confirmButtonText: '确定',
      }
      const check = await checkReminderById(row.id)
      if (!(typeof check.data === 'boolean' && check.data === true)) {
        promptConfig = {
          title: '',
          content: `${check.msg}。是否确定下载？`,
          type: 'warning',
          confirmButtonText: '确定',
        }
      }
      this.$confirm(promptConfig.content, promptConfig.title, {
        confirmButtonText: promptConfig.confirmButtonText,
        cancelButtonText: '取消',
        type: promptConfig.type
      }).then(() => {
        this.downLoadCertificates(row)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    downLoadCertificates(row) {
      downLoadCertificates(row.id).then(response =>{
        // console.log(response)
        const contentType = response.headers['content-type'] || 'application/octet-stream';
        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        // 创建下载链接
        const link = document.createElement('a');
        link.href = url;
        // 使用服务器返回的文件名，如果没有则使用默认名称
        const disposition = response.headers['content-disposition']
        const filename = disposition
          ? decodeURI(disposition.substring(disposition.indexOf('filename=') + 9, disposition.length))
          : 'downloaded_file';
        link.setAttribute('download', filename.trim());
        // 触发点击事件
        document.body.appendChild(link);
        link.click();
        // 释放Blob URL
        window.URL.revokeObjectURL(url);
        // 移除链接元素
        document.body.removeChild(link);
      })
    },
    // 反馈缺证情况
    feedback(type) {
      this.showFeedbackLackDialog = true
      if (type === 1) {
        // 缺证反馈
        this.lackCertificateFeedback = true
        this.feedbackData.type = 1
      }
    },
    // 上传附件
    uploadAttachment() {
      // 创建 input 元素
      const inputAttachment = document.createElement('input')
      // 设置 input 类型为文件
      inputAttachment.type = 'file'
      // 设置 input 的 accept 属性，限制文件类型为图片
      inputAttachment.accept = '.jpg, .jpeg, .png, .pdf, .xlsx, .docx, .doc'
      // 隐藏input节点
      inputAttachment.style.display = 'none'
      // 将 input 添加到页面中
      document.body.appendChild(inputAttachment)
      // 模拟点击 input，打开文件选择对话框
      inputAttachment.click();
      // 添加 change 事件监听器，处理文件选择后的逻辑
      inputAttachment.addEventListener('change', () => {
        const file = inputAttachment.files[0]
        // console.log(file)
        this.feedbackData.attachment.push(file)
        // 移除 input 元素，可根据需要保留或移除
        document.body.removeChild(inputAttachment)
      });
    },
    // 删除缺证反馈附件
    delFeedbackAttachment(file, index) {
      console.log(file, index)
      this.feedbackData.attachment.splice(index, 1)
    },
    // 立即上报
    reportImmediately() {
      // console.log(this.feedbackData)
      // 校验数据
      // 缺证反馈，证书分类不能为空
      // console.log(this.feedbackData.classificationId)
      if (this.feedbackData.type === 1 && !this.feedbackData.classificationId?.length) {
        return this.$message.error('证书分类是必填项!')
      }
      // 上报内容和上传附件不可同时为空
      if (!(!isStringEmpty(this.feedbackData.content) || !isArrayEmpty(this.feedbackData.attachment))) {
        return  this.$message.error('上报内容和上传附件不可同时为空')
      }
      // 电话号码或者邮箱
      // const contact = this.feedbackData.contact
      // if(contact && !validateContact(contact)) return this.$message.error('请输入正确的联系方式')
      const formData = new FormData()
      for (const key in this.feedbackData) {
        switch (key) {
          case 'attachment':
            const file = this.feedbackData.attachment[0]
            file && formData.append('file', file)
            break
          case 'classificationId':
            const idArr = this.feedbackData[key]
            !isArrayEmpty(idArr) && formData.append('classificationId', idArr[idArr.length - 1])
            break
          default:
            formData.append(`${key}`, this.feedbackData[key])
        }
      }
      this.$confirm('请确定是否要上报？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(async () => {
        const res = await addFeedback(formData)
          if (res.code === 200) {
            this.$message.success('反馈成功')
            this.showFeedbackLackDialog = false
          }
      }).catch(() => {});
    },
    // 反馈弹窗隐藏
    hideFeedbackDialog() {
      // 恢复初始化数据
      this.lackCertificateFeedback = false
      this.feedbackData.type = null
      this.feedbackData.classificationId = ''
      this.feedbackData.content = ''
      this.feedbackData.attachment = []
      this.feedbackData.contact = ''
    },
    // 打开新页面
    openNewPage(page) {
      window.open(`/web/#/${page}`, '_blank');
    }
  },
};
</script>
<style lang="less" src="./style.less" scoped></style>
<style>
.el-tooltip__popper{
  text-align: center;
  background: rgba(25, 25, 25, .9) !important;
}
.el-tooltip__popper[x-placement^=top] .popper__arrow:after{
  border-top-color: #1F2125 !important;
}


</style>
